import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { formatINR } from "@/lib/api";
import { TrendingUp } from "lucide-react";

export const MetalRatesBar = () => {
  const { settings } = useSettings();
  if (!settings || settings.gold_rate_24k == null) return null;

  return (
    <div className="bg-obsidian text-white/90 text-xs sm:text-sm" data-testid="metal-rates-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-center sm:justify-between gap-4">
        <div className="flex items-center gap-1.5 text-gold">
          <TrendingUp className="w-3.5 h-3.5" />
          <span className="overline hidden sm:inline">Today's Rates</span>
        </div>
        <div className="flex items-center gap-4 sm:gap-6">
          <span className="flex items-center gap-1.5" data-testid="rate-gold">
            <span className="w-2 h-2 rounded-full bg-gold inline-block" />
            <span className="text-white/60">24K Gold</span>
            <strong className="text-white font-semibold">{formatINR(settings.gold_rate_24k)}/g</strong>
          </span>
          <span className="flex items-center gap-1.5" data-testid="rate-silver">
            <span className="w-2 h-2 rounded-full bg-silver inline-block" />
            <span className="text-white/60">995 Silver</span>
            <strong className="text-white font-semibold">{formatINR(settings.silver_rate_995)}/g</strong>
          </span>
        </div>
      </div>
    </div>
  );
};
